import type { Location } from 'react-router-dom';

type RewriteUrlProps = {
  from: string;
  to: string;
  location: Location;
};

export const rewriteUrl = ({ from, to, location }: RewriteUrlProps) => {
  let url = location.pathname.replace(from, to);
  if (location.search) {
    url += `?${location.search.replace(/^\?/, '')}`;
  }
  if (location.hash) {
    url += `#${location.hash.replace(/^#/, '')}`;
  }
  return url;
};
